// extracted by mini-css-extract-plugin
export default {"redBorderShaking":"Remaining_redBorderShaking__JzZk8","shake":"Remaining_shake__4xOly"};